module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-18-ec8513ea6425effeebe2b7e4491e67b2.png";